import React, { useState } from 'react';
import { COLORS } from '../../../../utils/constants';
import { adminAPI } from '../../../../services/api';
import { ModalWrapper } from './ModalComponents';

const AddWalletModal = ({ clientId, onClose, onSuccess }) => {
  const [address, setAddress] = useState('');
  const [chain, setChain] = useState('ETH');
  const [isPrimary, setIsPrimary] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const supportedChains = [
    { value: 'ETH', label: 'Ethereum (ETH)' },
    { value: 'USDT-ERC20', label: 'USDT (ERC-20)' },
    { value: 'USDT-TRC20', label: 'USDT (TRC-20)' },
    { value: 'BSC', label: 'BNB Smart Chain' },
    { value: 'USDT-BEP20', label: 'USDT (BEP-20)' },
    { value: 'POLYGON', label: 'Polygon' },
    { value: 'ARBITRUM', label: 'Arbitrum' },
    { value: 'USDC-ERC20', label: 'USDC (ERC-20)' },
    { value: 'BTC', label: 'Bitcoin' },
  ];

  // Validate address format based on chain
  const validateAddress = (addr, chainType) => {
    if (!addr || addr.trim() === '') return false;
    
    // TRC-20 (Tron) addresses start with 'T' and are 34 chars
    if (chainType === 'USDT-TRC20') {
      return addr.startsWith('T') && addr.length === 34;
    }
    
    // Bitcoin addresses
    if (chainType === 'BTC') {
      // Legacy (1...), SegWit (3...), Native SegWit (bc1...)
      return (addr.startsWith('1') || addr.startsWith('3') || addr.startsWith('bc1')) && addr.length >= 26;
    }
    
    // ERC-20, BEP-20, and other EVM chains (0x...)
    return addr.startsWith('0x') && addr.length === 42;
  };

  const handleSubmit = async () => {
    if (!validateAddress(address, chain)) {
      if (chain === 'USDT-TRC20') {
        setError('Введите корректный TRC-20 адрес (T...)');
      } else if (chain === 'BTC') {
        setError('Введите корректный Bitcoin адрес');
      } else {
        setError('Введите корректный адрес кошелька (0x...)');
      }
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      await adminAPI.addClientWallet(clientId, {
        address,
        chain,
        is_primary: isPrimary
      });
      onSuccess();
    } catch (err) {
      setError(err.response?.data?.detail || 'Ошибка добавления кошелька');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalWrapper title="Добавить кошелёк" onClose={onClose}>
      {error && (
        <div style={{
          padding: '10px',
          backgroundColor: `${COLORS.danger}20`,
          borderRadius: '8px',
          color: COLORS.danger,
          fontSize: '13px',
          marginBottom: '16px',
        }}>
          {error}
        </div>
      )}

      <div style={{ marginBottom: '16px' }}>
        <label style={{ display: 'block', color: COLORS.textSecondary, fontSize: '13px', marginBottom: '6px' }}>Адрес кошелька</label>
        <input
          type="text"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          placeholder="0x..."
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: COLORS.background,
            border: `1px solid ${COLORS.border}`,
            borderRadius: '8px',
            color: COLORS.text,
            fontSize: '14px',
            fontFamily: 'monospace',
            boxSizing: 'border-box',
          }}
        />
      </div>

      <div style={{ marginBottom: '16px' }}>
        <label style={{ display: 'block', color: COLORS.textSecondary, fontSize: '13px', marginBottom: '6px' }}>Сеть</label>
        <select
          value={chain}
          onChange={(e) => setChain(e.target.value)}
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: COLORS.background,
            border: `1px solid ${COLORS.border}`,
            borderRadius: '8px',
            color: COLORS.text,
            fontSize: '14px',
          }}
        >
          {supportedChains.map(c => (
            <option key={c.value} value={c.value}>{c.label}</option>
          ))}
        </select>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={isPrimary}
            onChange={(e) => setIsPrimary(e.target.checked)}
            style={{ width: '16px', height: '16px' }}
          />
          <span style={{ color: COLORS.textSecondary, fontSize: '13px' }}>Основной кошелёк</span>
        </label>
      </div>

      <button
        onClick={handleSubmit}
        disabled={loading || !address}
        style={{
          width: '100%',
          padding: '14px',
          backgroundColor: loading || !address ? COLORS.border : COLORS.primary,
          border: 'none',
          borderRadius: '8px',
          color: '#000',
          fontSize: '15px',
          fontWeight: '600',
          cursor: loading || !address ? 'not-allowed' : 'pointer',
        }}
      >
        {loading ? 'Добавление...' : 'Добавить кошелёк'}
      </button>
    </ModalWrapper>
  );
};

export default AddWalletModal;
